export default __webpack_public_path__ + "static/media/aramex.f8772412.svg";